import { render, staticRenderFns } from "./SidePanelNavigator.vue?vue&type=template&id=498d6a2d&scoped=true&"
import script from "./SidePanelNavigator.vue?vue&type=script&lang=ts&"
export * from "./SidePanelNavigator.vue?vue&type=script&lang=ts&"
import style0 from "./SidePanelNavigator.vue?vue&type=style&index=0&id=498d6a2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498d6a2d",
  null
  
)

export default component.exports